import { useState } from 'react';
import { getSignedUrl, isUrlExpired } from '../helpers/S3Helpers';
import { GET_SIGNED_URL_PATH } from "../constants/ApiConstants";

function useFileDownloader(blank = false) {
    const [loading, setLoading] = useState(false);

    const downloadFile = async (resource_type, resourceName, fileName) => {
        setLoading(true);

        try {
            const signedUrl = await getSignedUrl(GET_SIGNED_URL_PATH, resource_type, resourceName, fileName); // Assuming 'download' is the appropriate action for getting the signed URL

            if (signedUrl && !isUrlExpired(signedUrl)) {
                const link = document.createElement('a');
                link.href = signedUrl;
                link.download = fileName;
                if (blank) {
                    link.target = '_blank';
                }
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                console.error("Failed to get a valid signed URL from the backend.");
            }
        } catch (error) {
            console.error("Error fetching the signed URL and downloading the file:", error);
        } finally {
            setLoading(false);
        }
    };

    return [downloadFile, loading];
}

export default useFileDownloader;
